'use client'

import {
  PageEventProps,
  useDispatchPageEvent
} from '@/hooks/useDispatchPageEvent'

export interface AnalyticsProps {
  pageEvent: PageEventProps
}

export const Analytics = ({ pageEvent }: AnalyticsProps) => {
  useDispatchPageEvent(pageEvent)

  return <></>
}
